import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CHOSEN_CORE_VALUES_LIMIT } from "@/lib/constants";
import { usePreferredHaptics } from "@/lib/hooks/usePreferredHaptics";
import {
	chartPieIcon as chartPieOutlineIcon,
	compassIcon,
	homeIcon as homeSolidIcon,
	sunIcon as sunOutlineIcon,
} from "@/lib/icons/@heroicons/react/24/outline";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { useMyData } from "@/lib/query/functions/user/data";
import { Routes } from "@/lib/router";
import { PerfectDay } from "@/pages/app/perfect-day";
import { YourMission } from "@/pages/app/your-mission";
import { Dashboard } from "@/pages/dashboard";
import { CoreValuesDashboard } from "@/pages/modules/core-values/dashboard";

export function TabsWrapper() {
	const { t } = useTranslation();
	const PreferredHaptics = usePreferredHaptics();
	const [myData] = useMyData();

	const { data } = useQuery(queryOptions_coreValuesChosen());
	const showBar = (data?.length ?? 0) === CHOSEN_CORE_VALUES_LIMIT;

	return (
		<IonTabs>
			<IonRouterOutlet id="tabs">
				<Route exact path={Routes.Dashboard()} component={Dashboard} />
				<Route exact path={Routes.CoreValuesDashboard()} component={CoreValuesDashboard} />
				<Route exact path={Routes.PerfectDayDashboard()} component={PerfectDay} />
				<Route exact path={Routes.YourMission()} component={YourMission} />
			</IonRouterOutlet>

			<IonTabBar
				slot="bottom"
				hidden={!showBar}
				className="ion-bg-white *:ion-text-brown-700 *:ion-p-2 rounded-t-3xl shadow-[0_0_16px_0_--alpha(var(--color-black)/6%)]"
			>
				<IonTabButton
					tab="dashboard"
					href={Routes.Dashboard()}
					onClick={() => PreferredHaptics.impact()}
				>
					<IonIcon icon={homeSolidIcon} className="size-6" />
					<IonLabel className="text-xs">{t("dashboard.name")}</IonLabel>
				</IonTabButton>

				<IonTabButton
					tab="core-values"
					href={Routes.CoreValuesDashboard()}
					onClick={() => PreferredHaptics.impact()}
				>
					<IonIcon icon={chartPieOutlineIcon} className="size-6" />
					<IonLabel className="text-xs">{t("core-values.name")}</IonLabel>
				</IonTabButton>

				<IonTabButton
					tab="perfect-day"
					href={Routes.PerfectDayDashboard()}
					onClick={() => PreferredHaptics.impact()}
				>
					<IonIcon icon={sunOutlineIcon} className="size-6" />
					<IonLabel className="text-xs">{t("perfect-day.name")}</IonLabel>
				</IonTabButton>

				{myData.perfectDay.hasCompleted && (
					<IonTabButton
						tab="your-mission"
						href={Routes.YourMission()}
						onClick={() => PreferredHaptics.impact()}
					>
						<IonIcon icon={compassIcon} className="size-6" />
						<IonLabel className="text-xs">{t("your-mission.name")}</IonLabel>
					</IonTabButton>
				)}
			</IonTabBar>
		</IonTabs>
	);
}
